import React, { useEffect, useRef, useState } from 'react';
import Icon from './icons';

// Textos idênticos aos usados hoje em setConfirmAction() no VMDetailPage.
export const CONFIRM_TEXTS = {
  shutdown: { label: 'Desligar',   description: 'Envia sinal ACPI para desligar a VM.' },
  reboot:   { label: 'Reiniciar',  description: 'Envia sinal ACPI para reiniciar a VM.' },
  stop:     { label: 'Hard Stop',  description: 'Força o desligamento imediato da VM, como retirar o cabo de energia.' },
  reset:    { label: 'Hard Reset', description: 'Força o reset imediato da VM, como apertar o botão físico de reset.' },
};

function VMHeaderActions({ status, actionLoading, consoleLoading, consoleActive, onStart, onRequestConfirm, onOpenConsole }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const wrapRef = useRef(null);
  const moreBtnRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') {
        setMenuOpen(false);
        if (moreBtnRef.current) moreBtnRef.current.focus();
      }
    };
    const onDown = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener('keydown', onKey);
    document.addEventListener('mousedown', onDown);
    return () => {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('mousedown', onDown);
    };
  }, [menuOpen]);

  const pick = (action) => {
    setMenuOpen(false);
    onRequestConfirm(action);
  };

  if (status !== 'running') {
    return (
      <div className="vmd-actions" ref={wrapRef}>
        <button type="button" className="vmd-btn primary" onClick={onStart} disabled={actionLoading}>
          <Icon name="play" size={16} /> Iniciar
        </button>
        <button type="button" className="vmd-btn ghost" disabled title="VM desligada">
          <Icon name="monitor" size={16} /> Console
        </button>
      </div>
    );
  }

  return (
    <div className="vmd-actions" ref={wrapRef}>
      <button
        type="button"
        className="vmd-btn primary"
        onClick={onOpenConsole}
        disabled={consoleLoading || consoleActive}
        aria-current={consoleActive ? 'true' : undefined}
      >
        <Icon name="monitor" size={16} /> {consoleLoading ? 'Abrindo…' : 'Console'}
      </button>
      <button type="button" className="vmd-btn ghost" onClick={() => onRequestConfirm('shutdown')} disabled={actionLoading}>
        <Icon name="power" size={16} /> Desligar
      </button>
      <div className="vmd-more">
        <button
          ref={moreBtnRef}
          type="button"
          className="vmd-btn ghost"
          aria-haspopup="menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(o => !o)}
          disabled={actionLoading}
        >
          Mais <Icon name="chev" size={14} />
        </button>
        {menuOpen && (
          <div className="vmd-menu" role="menu">
            <button type="button" role="menuitem" disabled={actionLoading} onClick={() => pick('reboot')}>
              <Icon name="rotate" size={16} /> Reiniciar (ACPI)
            </button>
            <div className="vmd-menu-sep" />
            <button type="button" role="menuitem" className="danger" disabled={actionLoading} onClick={() => pick('stop')}>
              <Icon name="octagon" size={16} /> Hard Stop
            </button>
            <button type="button" role="menuitem" className="danger" disabled={actionLoading} onClick={() => pick('reset')}>
              <Icon name="zap" size={16} /> Hard Reset
            </button>
            <div className="vmd-menu-hint">Ações forçadas pedem confirmação.</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default VMHeaderActions;
